import useAuth from "./AuthProvider";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { AppState } from "../Store";
import { connect } from "react-redux";
import { PropsWithChildren } from "react";
import { AuthState } from "../Store/Auth/reducers";
import { UserRoleEnum } from "../Models/Auth";
interface PrivateRouteProps extends RouteProps {
  auth: AuthState;
  allowedRoles: UserRoleEnum[];
}

function PrivateRoute({
  children,
  auth,
  allowedRoles,
  ...rest
}: PropsWithChildren<PrivateRouteProps>) {
  console.log(children, rest);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.user ? (
          allowedRoles.includes(auth.user.role.type) ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location },
              }}
            />
          )
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

const mapStateToProps = (state: AppState) => ({
  auth: state.auth,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
